<template>
  <div v-if="sources.length" class="sources-container">
    <SourceComponent
      v-for="(source, index) in sources"
      :key="index"
      :title="
        assistantType === AssistantType.LegalAssistant
          ? source.title
          : source.doc_id
      "
      :description="source.section"
      :clickable="true"
      @click="() => openDocument(source.documentURL)"
    />
  </div>
</template>
<script setup lang="ts">
import SourceComponent from '@/components/LegalAssistant/SourceComponent.vue';
import { SourceDTO } from '@/dto/QuestionResponseDTO';
import { AssistantType } from '@/models/assistant-types';
import { useToasterStore } from '@/stores/useToasterStore';
import { useI18n } from 'vue-i18n';

interface Props {
  sources: SourceDTO[];
  assistantType: AssistantType;
}

defineProps<Props>();
const toaster = useToasterStore();
const { t } = useI18n();

function openDocument(url: string): void {
  if (url) window.open(url, '_blank');
  else
    toaster.error({
      title: t('message_sources.url.error_title'),
      body: t('message_sources.url.error_body')
    });
}
</script>
<style scoped lang="scss">
.sources-container {
  margin-top: $space-3;
}
</style>
